import { memo } from "react"
import { toMoneyFormat } from "utils";

const FinancialState = props => {
    const { data } = props;

    return (
        <div className="wrap-box tp-22 mb-4">
            <div className="financial-state">
                <h2 className="title tp-34 mb-2">وضعیت مالی</h2>

                <ul>
                    <li>
                        <div>
                            <i className="fa-light fa-wallet tp-3"></i>
                            <span className="sec-title tp-34">موجودی</span>
                        </div>

                        <b className="tp-34">
                            {toMoneyFormat(data.data.wallet.balance)} <span className="text-xs font-normal">تومان</span>
                        </b>
                    </li>

                    <li>
                        <div>
                            <i className="fa-light fa-credit-card tp-3"></i>
                            <span className="sec-title tp-34">موجوی قابل برداشت</span>
                        </div>

                        <b className="tp-34">
                            {toMoneyFormat(data.data.wallet.withdrawble_balance)} <span className="text-xs font-normal">تومان</span>
                        </b>
                    </li>

                    <li>
                        <div>
                            <i className="fa-light fa-building-columns tp-3"></i>
                            <span className="sec-title tp-34">تسویه شده</span>
                        </div>

                        <b className="tp-34">
                            {toMoneyFormat(data.data.withdraw_sum.withdrew_amount)} <span className="text-xs font-normal">تومان</span>
                        </b>
                    </li>

                    <li>
                        <div>
                            <i className="fa-light fa-hourglass-start tp-3"></i>
                            <span className="sec-title tp-34">در انتظار تسویه</span>
                        </div>

                        <b className="tp-34">
                            {toMoneyFormat(data.data.withdraw_sum.pending_amount)} <span className="text-xs font-normal">تومان</span>
                        </b>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default memo(FinancialState);